<form class="" [formGroup]="formGroup">
  <div class="hide-arrow-input" [ngStyle]="{marginTop:marginTop}">
    <mat-form-field [appearance]="appearance"
      [floatLabel]="floatLabel"
      style="max-width: 100%;width: 100%">
      @if (title) {
        <mat-label>{{ title }}</mat-label>
      }
      <input (focusin)="focusInInput()" (focusout)="focusOutInput()"
        matInput
        formControlName="value"
        style="font-weight: bold;font-size: large;" type="number">
      @if (showClearButton) {
        <mat-icon matPrefix style="cursor: pointer"
          (click)="$event.stopPropagation();unset()" color="primary">cancel
        </mat-icon>
      }
      <div class="flex-center-center" style="width: 60px;margin-top: 5px;margin-left: 5px" matSuffix>
        <div style="margin-right: 5px"
          (click)="clickRemove()" class="background-color-primary size-button-add-remove pointer"
          [ngClass]="{disbled:(disableRemove$|async)||formGroup.disabled}">
          <mat-icon>remove</mat-icon>
        </div>
        <div (click)="clickSum()" class="background-color-primary size-button-add-remove pointer"
          [ngClass]="{disbled:(disableAdd$|async)||formGroup.disabled}">
          <mat-icon>add</mat-icon>
        </div>

      </div>
      @if (hintMessage) {
        <mat-hint>{{ hintMessage }}</mat-hint>
      }
    </mat-form-field>
  </div>
</form>
